import { lazyModal } from '@/lib/lazy-load'

export const NotifModal = lazyModal(() => import('./NotifModal'))
